import script from "./StructureAccessChips.vue?vue&type=script&setup=true&lang=js"
export * from "./StructureAccessChips.vue?vue&type=script&setup=true&lang=js"

import "./StructureAccessChips.vue?vue&type=style&index=0&id=7e9febd1&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9febd1"]])

export default __exports__